import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "p-m-0" }, "Eventos para el Sitio WWW", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" No hay eventos todavía. ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Buscando los eventos que tengamos definidos, en breve se los mostraré. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_EditEventDialog = _resolveComponent("EditEventDialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_DataTable, {
      value: _ctx.events,
      paginator: true,
      rows: 10,
      expandedRows: _ctx.expandedRows,
      "onUpdate:expandedRows": _cache[0] || (_cache[0] = ($event: any) => (_ctx.expandedRows = $event)),
      dataKey: "id",
      rowHover: true,
      loading: _ctx.loading,
      paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
      rowsPerPageOptions: [10, 25, 50],
      currentPageReportTemplate: "Viendo {first} a {last} de {totalRecords} eventos",
      globalFilterFields: ['title', 'state'],
      filters: _ctx.filters,
      "onUpdate:filters": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters = $event)),
      showGridlines: "",
      responsiveLayout: "scroll"
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", null, [
            _createVNode(_component_Button, {
              icon: "pi pi-plus-circle",
              label: "Agregar Evento",
              class: "p-button-rounded p-button-text p-ml-1 p-button-success",
              onClick: _ctx.addNew
            }, null, 8, ["onClick"])
          ])
        ])
      ]),
      empty: _withCtx(() => [
        _hoisted_3
      ]),
      loading: _withCtx(() => [
        _hoisted_4
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          header: "Titulo",
          sortable: "",
          field: "title"
        }),
        _createVNode(_component_Column, {
          header: "Descripción",
          sortable: "",
          field: "description"
        }),
        _createVNode(_component_Column, {
          header: "Empieza el",
          sortable: "",
          field: "startDate"
        }),
        _createVNode(_component_Column, {
          header: "Visible el",
          sortable: "",
          field: "visibleDate"
        }),
        _createVNode(_component_Column, {
          header: "Estado",
          sortable: "",
          field: "state"
        }),
        _createVNode(_component_Column, {
          header: "Tags",
          field: "tags"
        }, {
          body: _withCtx(({ data }) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.tags, (tag) => {
              return (_openBlock(), _createElementBlock("span", { key: tag }, _toDisplayString(tag) + _toDisplayString(data.tags.length > 1 ? ',' : ''), 1))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Speaker",
          field: "speakers"
        }, {
          body: _withCtx(({ data }) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.speakers, (speaker) => {
              return (_openBlock(), _createElementBlock("span", {
                key: speaker.name
              }, _toDisplayString(speaker.name) + " " + _toDisplayString(speaker.lastName) + _toDisplayString(data.speakers.length > 1 ? ', ' : ''), 1))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Typeform Link",
          field: "typeForm"
        }),
        _createVNode(_component_Column, {
          header: "Paises",
          sortable: "",
          field: "countries"
        }, {
          body: _withCtx(({ data }) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.countries, (country) => {
              return (_openBlock(), _createElementBlock("span", { key: country }, _toDisplayString(country) + _toDisplayString(data.countries.length > 1 ? ', ' : ''), 1))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Tipo",
          sortable: "",
          field: "type"
        }),
        _createVNode(_component_Column, {
          headerStyle: "width: 8rem; text-align: center",
          bodyStyle: "text-align: center; overflow: visible"
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-trash",
              onClick: ($event: any) => (_ctx.onRemove(data)),
              class: "p-mr-1"
            }, null, 8, ["onClick"]),
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-pencil",
              onClick: ($event: any) => (_ctx.onEdit(data))
            }, null, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "expandedRows", "loading", "filters"]),
    (_ctx.showEditDialog)
      ? (_openBlock(), _createBlock(_component_EditEventDialog, {
          key: 0,
          event: _ctx.editingEvent,
          show: _ctx.showEditDialog,
          onOnCancel: _ctx.onCancelEditDialog,
          onOnSave: _ctx.onSaveEvent
        }, null, 8, ["event", "show", "onOnCancel", "onOnSave"]))
      : _createCommentVNode("", true)
  ]))
}